import { useNavigate } from 'react-router-dom';
import { DEFAULT_PATH } from '@/routes/paths';
import { Container } from './Logo.styles';

type Props = {
  logoIcon: React.ReactNode;
};

export const Logo = ({ logoIcon }: Props) => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate(DEFAULT_PATH);
  };

  return (
    <Container onClick={handleLogoClick} data-testid="Logo">
      {logoIcon}
    </Container>
  );
};
